import { createAsyncThunk } from 'app/store/utils';
import { getPlayAudioLink } from 'app/store/AudioPlayer/selectors';
import axios from 'axios';
import { SongStatusType } from 'types/song';
import { AudioPlayerAudioInstance } from 'app/store/AudioPlayer/slice.types';
import { fetchAudioWithSrc } from './effects.utils';

export const fetchAudioForPlayingEffect = createAsyncThunk<
  AudioPlayerAudioInstance | null,
  AudioPlayerAudioInstance
>('audioPlayer/fetchAudioForPlaying', async (data, { getState }) => {
  const { audioGuid, parentGuid = '' } = data;
  const state = getState();

  const fetchedAudio = await fetchAudioWithSrc({
    audioGuid,
    parentGuid,
    state,
  });

  if (!fetchedAudio || !fetchedAudio?._links.play?.href) {
    throw new Error('Audio is not playable');
  }

  const midi = fetchedAudio.container === 'midi';

  return {
    ...data,
    audioSrc: fetchedAudio._links.play?.href,
    waveformSrc: midi ? undefined : fetchedAudio._links.waveform?.href,
    songTitle: data.songTitle || '',
    audioTitle: fetchedAudio.title || '',
    songStatus: data.songStatus || SongStatusType.IN_CREATION,
    isMidi: midi,
  };
});

export const fetchWaveformFeatureFlag = createAsyncThunk(
  'audioPlayer/fetchWaveformFeatureFlag',
  async (
    { isWaveformFeatureEnabled }: { isWaveformFeatureEnabled?: boolean },
    { getState }
  ) => {
    if (isWaveformFeatureEnabled !== undefined) {
      return isWaveformFeatureEnabled;
    }

    const state = getState();
    const link = getPlayAudioLink(state);

    if (!link) {
      return false;
    }

    try {
      const { data } = await axios.request({
        url: link?.href,
        method: 'GET',
        headers: { Accept: 'application/json+schema' },
        withCredentials: true,
      });

      return Boolean(
        data?.response?.schema?.properties?.query?.properties?.waveform
      );
    } catch (e) {
      return false;
    }
  }
);
